module.exports = __webpack_public_path__ + "img/szegyenlos_lanyok_5.5ce20a86.jpg";